import data from './variants.json' with {type: 'json'};
// Rare colour variants, gacha only. One table feeds the runtime material
// override and the Blender thumbnail render (scripts/generate-models.py).
export const RARE_RATE = data.rate;
export const variantTable = () => data.variants;
export const VARIANT_KINDS = Object.keys(data.variants);
export const variantIds = kind => Object.keys(data.variants[kind] ?? {});
export const hasVariants = kind => variantIds(kind).length > 0;
export const isVariant = (kind, id) => typeof id === 'string' && Object.hasOwn(data.variants[kind] ?? {}, id);
export const variantMaterial = (kind, id, materialName) =>
  isVariant(kind, id) ? data.variants[kind][id].materials[materialName] ?? null : null;
// A roll in [0, 1): below the rate picks one of the kind's variants evenly.
export function chooseVariant(kind, roll) {
  const ids = variantIds(kind);
  if (!ids.length || !(roll < RARE_RATE)) return undefined;
  return ids[Math.min(ids.length - 1, Math.floor(Math.max(0, roll) / RARE_RATE * ids.length))];
}
// Optional per-variant behaviour: pull-apart physics and strand material.
export const variantTear = (kind, id) => (isVariant(kind, id) ? data.variants[kind][id].tear ?? null : null);
export const variantMood = (kind, id) => (isVariant(kind, id) ? data.variants[kind][id].mood ?? null : null);
export const variantGlitter = (kind, id) => (isVariant(kind, id) ? data.variants[kind][id].glitter ?? null : null);
export const variantBridgeFromCut = (kind, id) => isVariant(kind, id) && data.variants[kind][id].bridge === 'cut';
// Variants without a rendered thumbnail reuse the base image through a CSS filter.
export const variantThumbnailFilter = (kind, id) => (isVariant(kind, id) ? data.variants[kind][id].css ?? '' : '');
export const variantHasImage = (kind, id) => isVariant(kind, id) && !data.variants[kind][id].css;
